<template>
  <DataTable
    ref="DataTable"
    :data-model="'Questionnaires'"
    :permission-name="'Customers'"
    :allow-delete="false"
    :allow-edit="false"
    :allow-create="false"
    :exclude-fields="['id']"
    :display-name-plural="$t('entities.Questionnaire.Plural')"
    :display-name-singular="$t('entities.Questionnaire.Singular')" />
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  },
};
</script>
<style scoped></style>
